import React, { useEffect, useState, useRef, use } from 'react';

import { Image } from '$partials/media';
import { formatPrice, formatRentFrequency } from '$utilities/format';
import { Carousel, CarouselNavigation, CarouselSlide, CarouselWrapper } from '$partials/base/carousel';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').HeroCarousel}
 */
const HeroCarousel = ({
    items
}) => {
    const [ featuredProperty , setFeaturedProperty ] = useState(items?.[0]);
    const randomizer = Math.floor(Math.random() * items.length);

    useEffect(() => {
        setFeaturedProperty(items[randomizer]);
    }, []);

    const page = featuredProperty?.page;
    const isBuy = (page?.__typename === 'PropertyPage') || (page?.__typename === 'PartnershipPropertyPage');
    const isUsd = (page?.__typename === 'PartnershipPropertyPage') || (page?.__typename === 'PartnershipRentalPropertyPage');

    const price = (
        isBuy ?
            isUsd ?
                formatPrice(page?.priceUsd, {currency: 'USD'})
                :
                formatPrice(page?.priceGbp)
            : isUsd ?
                `${formatPrice((page?.rentUsd), {currency: 'USD'})} ${formatRentFrequency(page?.partnershipRentFrequency)}`
                :
                `${formatPrice(page?.rentGbp)} ${formatRentFrequency(page?.rentFrequency)}`
    );

    const videoRef = useRef(null);

    useEffect(() => {
        setTimeout(() => {
            if (videoRef.current) {
                videoRef.current.defaultMuted = true;
                videoRef.current.muted = true;
                videoRef.current.autoplay = true;
            }
        }, 0);
    }, []);

    return (
        <div className='flex flex-wrap col-12 justify-between md-items-center height-100 featured-properties-carousel-container overflow-hidden'>
            {page && (
                <>
                    {/* Description */}
                    <div className='col-12 sm-col-6 md-col-4 flex flex-col py8 md-py0 pr5 pl5 md-pl6 lg-xlg-pl0'>
                        <a
                            className='link-reset'
                            href={page.url} >
                            <p className='type-style-5'>{price}</p>
                            <h3 className='type-style-3'>{page?.heading}</h3>
                            <div
                                className='rich-text type-style-5 mt4'>
                                <p className='type-style-5'>{page?.propertyName}</p>
                                <p className='type-style-5'>{page?.area} {page?.outwardCode}</p>
                            </div>
                        </a>
                    </div>
                    {page.heroVideo ? (
                        <div className='col-12 md-col-7 overflow-hidden aspect-video'>
                            <div className='swiper-wrapper'>
                                <a
                                    className='link-reset'
                                    href={page.url}>
                                    <div className='width-100 height-100'>
                                        <video
                                            autoPlay
                                            loop
                                            playsInline
                                            className='object-cover height-100 width-100'
                                            poster={page.listingMedia?.[0]?.image?.src}
                                            ref={videoRef}
                                            src={page.heroVideo.videoUrl}/>
                                    </div>
                                </a>
                            </div>
                        </div>
                    ) : (
                        <Carousel swiperConfig={{
                            slidesPerView: 1,
                            spaceBetween: 0,
                            breakpoints: {
                                640: {
                                    spaceBetween: 0,
                                },
                                1024: {
                                    spaceBetween: 1,
                                }
                            }
                        }}>
                            <div className='col-12 md-col-7 overflow-hidden'>
                                <CarouselWrapper className='swiper-wrapper'>
                                    <div className='hide md-show absolute-center-y z2 right right-0 mr6'>
                                        <CarouselNavigation look='col' />
                                    </div>
                                    <div
                                        className='md-hide absolute-center-y z2 left left-0 ml5'>
                                        <CarouselNavigation look='col' />
                                    </div>
                                    {page.listingMedia?.length > 0 && page.listingMedia.map((media, i) => {
                                        return (
                                            <CarouselSlide
                                                className='carousel-slide'
                                                key={media.image?.id}>
                                                <a
                                                    className='link-reset'
                                                    href={page.url}>
                                                    <Image
                                                        {...media.image}
                                                        height={12}
                                                        width={16} />
                                                </a>
                                            </CarouselSlide>
                                        );
                                    })}
                                </CarouselWrapper>
                            </div>
                        </Carousel>
                    )}
                </>
            )}
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default HeroCarousel;
